import { colorSchemeTokens } from '@sixui/ui/themes/base/colorScheme.stylex';
import { outlineTokens } from '@sixui/ui/themes/base/outline.stylex';
import { spacingTokens } from '@sixui/ui/themes/base/spacing.stylex';
import stylex from '@stylexjs/stylex';

import type { IContainerProps } from '~/components/utils/Container';

export type IQuoteProps = IContainerProps & {
  children: React.ReactNode;
  hasError?: boolean;
};

const styles = stylex.create({
  host: {
    borderLeftWidth: outlineTokens.width$lg,
    borderLeftStyle: 'solid',
    borderLeftColor: colorSchemeTokens.outline,
    paddingLeft: spacingTokens.padding$2,
    paddingTop: spacingTokens.padding$1,
    paddingBottom: spacingTokens.padding$1,
  },
  host$hasError: {
    borderLeftColor: colorSchemeTokens.error,
    color: colorSchemeTokens.error,
  },
});

export const Quote: React.FC<IQuoteProps> = (props) => {
  const { sx, children, hasError } = props;

  return (
    <div {...stylex.props(styles.host, hasError && styles.host$hasError, sx)}>
      {children}
    </div>
  );
};
